import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Email1FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EMAIL 1' htmlFor='input-email1' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='email1'>
          {({ field }) => (
            <Form.InputEmail
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-email1'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Email1FormGroup)
